<template>
  <v-navigation-drawer app v-model="drawer" :disable-resize-watcher="true" :clipped="true" :fixed="true" :right="true" width="40%" height="100%">
    <v-container v-bind="containerConfig">
      <v-row justify="end">
        <v-icon @click="drawer = !drawer" class="mr-2 mt-1" small>close</v-icon>
      </v-row>

      <transition name="page">
        <i4proForm v-if="renderForm" :page="page" :context="context" :origin="'page'" />
      </transition>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import * as HANDLERS from '@/helpers/types/handlers';
import { handleLoadRoute } from '@/helpers/page';
import store from '@/store';

export default {
  components: {
    i4proForm: () => import('@/components/layouts/i4pro-form')
  },

  data: () => ({
    drawer: false,
    renderForm: false,
    page: null,
    context: 'sidebar'
  }),

  computed: {
    schema() {
      if (this.page) {
        return store.getters['page/schema']({ page: this.page, mode: 'sidebar' });
      }

      return {};
    },

    containerConfig: () => store.getters['layout/getConfigLayout'].container
  },

  events: {
    [HANDLERS.OPEN_DRAWER_DINAMIC]: 'openDrawerDinamic',
    [HANDLERS.CLOSE_DRAWER_DINAMIC]: 'closeDrawerDinamic'
  },

  methods: {
    handleLoadRoute,

    openDrawerDinamic(renderForm, { page, mode }) {
      this.page = page;

      this.renderForm = renderForm;

      this.drawer = true;
      this.context = mode;
    },

    closeDrawerDinamic() {
      this.drawer = false;

      this.renderForm = false;

      this.page = null;
    }
  }
};
</script>
